export default __webpack_public_path__ + "static/How Reading Habits Shape a Child-a8e629612691717723aa2ea2de9513f1.jpg";